import { setLocalStorageItem } from "@/utils/localStorageUtility";
import apiCityCenter from "@/services/cityCenter/api/apiCityCenter";
import { login_url } from "@/common/endpoints";
import { routes } from "@/model/cityCenter/modules";
import store from "@/store";

let { resultModel } = require("@/model/cityCenter/result/resultModel");

function getSortedPermittedModules(item) {
  const permittedModules = item;
  let tempPermitted = [];
  for (let i = 0; i < permittedModules.length; i++) {
    tempPermitted.push(permittedModules[i]);
  }
  for (let i = 0; i < tempPermitted.length; i++) {
    if (tempPermitted[i].name === "Dashboard") {
      tempPermitted.splice(i, 1);
    }
  }
  //sorted temporary permitted items array without Dashboard
  tempPermitted.sort(function(a, b) {
    const nameA = a.title.toUpperCase();
    const nameB = b.title.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
  let sorted = [];
  //have the array named 'sorted' to keep Dashboard at first
  for (let i = 0; i < permittedModules.length; i++) {
    if (permittedModules[i].name === "Dashboard") {
      sorted.push(permittedModules[i]);
      break;
    }
  }
  //then pushed that sorted tempPermitted array items into array named as 'sorted' and using that array future purposes
  for (let i = 0; i < tempPermitted.length; i++) {
    sorted.push(tempPermitted[i]);
  }
  return sorted;
}

// Function to search for a key in JSON object
function searchJSONObj(key, obj) {
  for (let k in obj) {
    if (k === key) {
      return obj[k];
    } else if (typeof obj[k] === "object") {
      const result = searchJSONObj(key, obj[k]);
      if (result) {
        return result;
      }
    }
  }
  return null;
}

function storeInLocalStorage(item) {
  // storePermissionsInLocalStorage(item.data);
  // const sortedPermittedModules = getSortedPermittedModules(item.data);
  // let filteredSortedPermittedModules = new Array();
  // sortedPermittedModules.forEach(item => {
  //   const searchKey = item.route;
  //   const result = searchJSONObj(searchKey, routes);
  //   if (result) {
  //     let exist = false;
  //     filteredSortedPermittedModules.forEach(item => {
  //       if (searchKey === item.route) {
  //         exist = true;
  //       }
  //     });
  //     if (!exist) {
  //       filteredSortedPermittedModules.push(item);
  //     }
  //   }
  // });
  const userInfo = item.header;
  // saving in local storage
  // setLocalStorageItem(
  //   "permittedModules",
  //   JSON.stringify(filteredSortedPermittedModules)
  // );
  // console.log(userInfo);
  setLocalStorageItem("cityCenterUserInfo", JSON.stringify(userInfo));
  setLocalStorageItem("cityCenterLoggedIn", JSON.stringify(true));
  setLocalStorageItem("city-center-bearer-token", item.message);
}

function storePermissionsInLocalStorage(item) {
  const sortedPermittedModules = getSortedPermittedModules(item.data);
  let filteredSortedPermittedModules = [];
  sortedPermittedModules.forEach(item => {
    const searchKey = item.route;
    const result = searchJSONObj(searchKey, routes);
    if (result) {
      let exist = false;
      filteredSortedPermittedModules.forEach(item => {
        if (searchKey === item.route) {
          exist = true;
        }
      });
      if (!exist) {
        filteredSortedPermittedModules.push(item);
      }
    }
  });
  const constructedPermissions = convertPages(
    JSON.parse(JSON.stringify(filteredSortedPermittedModules))
  );
  setLocalStorageItem("eapLoggedIn", JSON.stringify(true));
  // setLocalStorageItem("eap-bearer-token", item.message);
  return [
    JSON.stringify(filteredSortedPermittedModules),
    JSON.stringify(constructedPermissions)
  ];
}
function convertPages(pages) {
  const rootPages = pages.filter(p => p.parentId === 0);

  function createSubItems(parentId) {
    const subPages = pages.filter(p => p.parentId === parentId);
    if (subPages.length === 0) {
      return null;
    }
    return subPages.map(p => ({
      entity: p.entity,
      icon: p.icon,
      id: p.id,
      name: p.name,
      route: p.route,
      title: p.title,
      children: createSubItems(p.id)
    }));
  }

  return rootPages.map(p => ({
    entity: p.entity,
    icon: p.icon,
    id: p.id,
    name: p.name,
    route: p.route,
    title: p.title,
    children: createSubItems(p.id)
  }));
}
/**
 * Login to City Center
 * @param {{username:String, password:String}} credential
 */
async function login(credential) {
  return apiCityCenter.loginPost(login_url, credential);
}

async function loginUser(payload) {
  const response = await login(payload);
  const data = response.data;
  if (data.header !== null) {
    resultModel = data;
    if (resultModel.code === 200) {
      if (payload.username !== "" && payload.password !== "") {
        if (resultModel.header.employeeId !== null) {
          if (
            payload.username.toLowerCase() ===
            resultModel.header.employeeId.toLowerCase()
          ) {
            storeInLocalStorage(resultModel);
            // // routing towards Dashboard
            // this.$router.replace({ name: "CityCenter_Dashboard" });
            // commitUser(context, user);
            // return Promise.resolve(returnOrganizedResponse);
          }
        }
      }
    }
  } else {
    return Promise.reject(data.message);
  }
}

function getStoredPermissions() {
  return store.getters["user/userPermissions"];
}

function getUnConstructedPermissions() {
  return store.getters["user/unConstructedUserPermissions"];
}

function getStoredUserInfo() {
  return store.getters["user/user"];
}
function getLoggedInInfo() {
  let loggedIn = false;
  const user = getStoredUserInfo();
  if (user) {
    loggedIn = true;
  }
  return loggedIn;
}
function getPayloadForPermissions() {
  return "/".concat(store.getters["user/user"]).concat("/CS");
}
export {
  loginUser,
  getStoredPermissions,
  getStoredUserInfo,
  getLoggedInInfo,
  storePermissionsInLocalStorage,
  getPayloadForPermissions,
  getUnConstructedPermissions
};
